<script lang="ts">
  import { clickOnKeyPress } from '$lib/actions/clickOnKeyPress';
  import type { IconComponentType } from '$src/types';
  import Loader from '$icons/LoaderIcon.svelte';
  import ChevronDown from '$icons/ChevronDownIcon.svelte';

  // Someone can try to make the size and hierarchy properties exclusive
  // I have been trying for too long now.

  // type size = { xs: true } | { sm: true } | { md: true } | { lg: true };
  // type hierarchy = { primary: true } | { secondary: true } | { tertiary: true };

  // type $$Props = {
  // 	label: string;
  // 	disabled?: boolean;
  // 	borderColor?: string;
  // 	iconLeft?: ComponentType;
  // 	iconRight?: ComponentType;
  // } & size;

  export let label = '';
  export let disabled = false;
  export let borderColor = '#D0DDD7';
  export let bgColor = '';
  export let border = false;
  export let clickOnKey: string = null;
  export let cls = '';
  export let noShadow = false;

  export let xs = false;
  export let sm = false;
  export let md = false;
  export let lg = false;
  export let icon = false;

  export let primary = false;
  export let secondary = false;
  export let tertiary = false;
  export let danger = false;
  export let red = false;
  export let black = false;
  export let purple = false;

  export let showLoader = false;
  export let isOnPostCreation = false;

  export let iconLeft: IconComponentType = null;
  export let iconRight: IconComponentType = null;

  export let violet = false;
  export let wFull = false;

  if (secondary) {
    border = true;
  }
</script>

<button
  on:keydown
  on:click
  on:mouseover
  on:focus
  on:mouseleave
  {disabled}
  class:disabled
  class:no-label={!label}
  class:xs
  class:sm
  class:md={md || (!xs && !sm && !lg)}
  class:lg
  class:icon
  class:primary={primary || (!secondary && !tertiary)}
  class:secondary
  class:tertiary
  class:green={!violet && !black && !danger}
  class:violet
  class:danger
  class:red
  class:black
  class:purple
  class:withShadow={!noShadow}
  class:border
  class:w-full={wFull}
  class="{cls} button flex flex-row justify-center items-center gap-2 active:enabled:opacity-90 font-switzer bg-white {$$props.class}"
  use:clickOnKeyPress={clickOnKey}
  style="border-color: {borderColor}; {bgColor && `background-color: ${bgColor}`}"
>
  {#if !showLoader}
    <slot name="icon-left">
      <svelte:component this={iconLeft} />
    </slot>

    {#if isOnPostCreation}
      <div class="rotate-90">
        <ChevronDown color={'white'} />
      </div>
    {:else}
      {#if label}
        <span class="min-w-max">
          {label}
        </span>
      {/if}

      <slot />
    {/if}

    <slot name="icon-right">
      <svelte:component this={iconRight} />
    </slot>
  {:else}
    <Loader />
  {/if}
</button>

<style type="postcss">
  .xs {
    @apply py-2 px-3.5 font-medium text-xs rounded-lg;
  }

  .sm {
    @apply py-2.5 px-4 font-medium text-sm rounded-lg;
  }

  .md {
    @apply py-3 px-5 font-medium text-sm rounded-[11px];
  }

  .icon {
    @apply py-3 px-2 font-medium text-sm rounded-[11px];
  }

  .lg {
    @apply py-[17px] px-7 font-semibold text-base rounded-14;
  }

  .disabled.primary {
    @apply bg-[#BAE5D1] cursor-not-allowed text-white;
  }

  .disabled.secondary {
    @apply bg-white cursor-not-allowed text-grey-transparency-dark-16 border border-garden-grey-100;
  }

  .disabled.tertiary {
    @apply bg-white cursor-not-allowed text-grey-transparency-dark-16 border border-garden-grey-100;
  }

  .button.primary.green {
    @apply text-white;
    transition: box-shadow 0.5s ease-in-out;
    background: linear-gradient(125.27deg, #0f9d58 24.26%, #037a4f 205.65%);
  }

  .button.primary.green.withShadow {
    box-shadow:
      0px 4px 12px rgba(15, 157, 88, 0.24),
      inset 0px 0.5px 0px rgba(255, 255, 255, 0.5);
  }

  .button.primary.violet {
    @apply text-[#505181] bg-[#E0E0F9] border-grey-transparency-dark-8;
    transition: box-shadow 0.5s ease-in-out;
  }
  .button.primary.violet:hover {
    @apply bg-[rgb(210,210,230)];
  }

  .button.primary.violet.withShadow {
    box-shadow:
      0px 4px 12px rgba(80, 81, 129, 0.24),
      inset 0px 0.5px 0px rgba(255, 255, 255, 0.5);
  }

  .button.primary.black {
    @apply bg-grey-transparency-dark text-white;
  }

  .disabled {
    @apply opacity-50;
  }

  .button.primary.black:focus:enabled {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 3px #f5f5f5;
  }

  .button.secondary.green {
    @apply text-garden-grey-600 border-garden-grey-300;
    transition: box-shadow 0.3s ease-in-out;
  }

  .button.secondary.violet {
    @apply text-[#505181] border-grey-transparency-dark-8;
    transition: box-shadow 0.3s ease-in-out;
  }

  .button.secondary.viole:hover {
    @apply bg-[#E0E0F97F];
  }

  .button.secondary.danger {
    @apply text-accent-red-50 border-garden-grey-300;
    transition: box-shadow 0.3s ease-in-out;
  }
  .button.secondary.danger:disabled {
    @apply text-opacity-60;
  }

  .button.primary.danger {
    @apply border-accent-red-50 border  bg-accent-red-50 text-white;
    transition: box-shadow 0.3s ease-in-out;
  }
  .button.primary.danger:disabled {
    @apply text-opacity-60;
  }

  .button.primary.danger:hover {
    -webkit-animation: vibrate-1 0.3s linear;
    animation: vibrate-1 0.3s linear;
  }

  .button.secondary.danger:hover:enabled {
    background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.05);
  }

  .button.tertiary {
    @apply border  border-white text-garden-grey-600;
  }
  .button.tertiary {
    @apply bg-garden-grey-100 border-garden-grey-200;
  }

  .button.primary.green:hover {
    background: linear-gradient(125.27deg, #148944 24.26%, #005227 205.65%);
  }

  .button.secondary.green:hover {
    background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.05);
  }

  .button.primary.green:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 3px #b4f3d1;
  }

  .button.primary.violet:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 3px #e0e0f9;
  }

  .button.secondary:focus:enabled {
    @apply bg-white;
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 3px #f5f5f5;
  }

  .button.tertiary:focus {
    transition: box-shadow 0.3s ease-in-out;
    box-shadow: 0px 0px 0px 4px #f5f5f5;
  }

  .button.primary.purple {
    @apply text-white border-[#21252914];
    transition: box-shadow 0.5s ease-in-out;
    background: linear-gradient(125.27deg, #505181 24.26%, #45479d 205.65%);
  }

  .button.primary.purple:hover {
    @apply bg-[#45479d];
  }

  .button.primary.purple.withShadow {
    box-shadow:
      0px 4px 12px rgba(80, 81, 129, 0.24),
      inset 0px 0.5px 0px rgba(255, 255, 255, 0.5);
  }

  .button.primary.purple:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 3px #e0e0f9;
  }

  .button.primary.purple:hover {
    background: #45479d;
  }

  .no-label {
    @apply p-3;
  }

  @keyframes vibrate-1 {
    0% {
      -webkit-transform: translate(0);
      transform: translate(0);
    }
    20% {
      -webkit-transform: translate(-2px, 2px);
      transform: translate(-2px, 2px);
    }
    40% {
      -webkit-transform: translate(-2px, -2px);
      transform: translate(-2px, -2px);
    }
    60% {
      -webkit-transform: translate(2px, 2px);
      transform: translate(2px, 2px);
    }
    80% {
      -webkit-transform: translate(2px, -2px);
      transform: translate(2px, -2px);
    }
    100% {
      -webkit-transform: translate(0);
      transform: translate(0);
    }
  }
</style>
